import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { FlyGarminLegacyBaseUrl, FlyAdminLegacyBaseUrl } from '@garmin-avcloud/avcloud-fly-web-common/_shared';
import { FLY_WEB_COMMON_CONFIG } from '@garmin-avcloud/avcloud-fly-web-common/config';
import { catchError, of } from 'rxjs';
let YarmouthSystemsService = /*#__PURE__*/(() => {
  class YarmouthSystemsService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.baseUrl = `${this.config.site === 'FGA' ? FlyGarminLegacyBaseUrl[this.config.environment] : '/flyadmin'}/api/v2/yarmouth/systems`;
    }
    getSystemIdRegex(deviceModelId) {
      const params = new HttpParams({
        fromObject: {
          deviceModelId
        }
      });
      return this.http.get(`${this.baseUrl}/system-id/format`, {
        params
      });
    }
    validateSystemId(systemId, deviceModelId) {
      const params = new HttpParams({
        fromObject: {
          systemId,
          deviceModelId
        }
      });
      return this.http.get(`${this.baseUrl}/system-id/validate`, {
        params
      });
    }
    updateSystemId(oldSystemId, newSystemId, masterAircraftUuid) {
      const payload = {
        oldSystemId: oldSystemId,
        newSystemId: newSystemId,
        masterAircraftUuid: masterAircraftUuid
      };
      return this.http.put(`${this.baseUrl}/system-id`, payload);
    }
    getSerialNumberRegex(deviceModelId) {
      const params = new HttpParams({
        fromObject: {
          deviceId: deviceModelId
        }
      });
      return this.http.get(`${this.baseUrl}/connected-cockpit-devices/serial-number/format`, {
        params
      });
    }
    validateSerialNumber(serialNumber, deviceModelId) {
      const params = new HttpParams({
        fromObject: {
          serialNumber,
          deviceModelId
        }
      });
      return this.http.get(`${this.baseUrl}/connected-cockpit-devices/serial-number/validate`, {
        params
      });
    }
    getConnextDeviceConfigurations(aircraftModelId, deviceModelId) {
      const params = new HttpParams({
        fromObject: {
          aircraftModelId,
          deviceModelId
        }
      });
      return this.http.get(`${this.baseUrl}/connext-device-configurations`, {
        params
      });
    }
    static {
      this.ɵfac = function YarmouthSystemsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || YarmouthSystemsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: YarmouthSystemsService,
        factory: YarmouthSystemsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return YarmouthSystemsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const jsonHttpOptions = {
  headers: new HttpHeaders({
    Accept: 'application/json'
  })
};
let YarmouthConnextService = /*#__PURE__*/(() => {
  class YarmouthConnextService {
    constructor() {
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.httpClient = inject(HttpClient);
      this.url = this.config.site === 'FALA' ? '/flyadmin' : this.config.site === 'FGA' ? `${FlyGarminLegacyBaseUrl[this.config.environment]}` : null;
    }
    getAircraftServices(aircraftUuid) {
      return this.httpClient.get(`${this.url}/api/connext/aircraft/${aircraftUuid}/services`, jsonHttpOptions).pipe(catchError(this.handleError(null)));
    }
    activateOtc(serialNumber) {
      const body = {
        serialNumber
      };
      return this.httpClient.post(`${this.url}/api/connext/activation/otc`, body, jsonHttpOptions).pipe(catchError(this.handleError(null)));
    }
    getServiceDetailsBySku(sku) {
      return this.httpClient.get(`${this.url}/api/connext/services/${sku}/details`, jsonHttpOptions).pipe(catchError(this.handleError(null)));
    }
    handleError(result) {
      return error => {
        console.error(error);
        return of(result);
      };
    }
    static {
      this.ɵfac = function YarmouthConnextService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || YarmouthConnextService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: YarmouthConnextService,
        factory: YarmouthConnextService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return YarmouthConnextService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let YarmouthConnextValidationService = /*#__PURE__*/(() => {
  class YarmouthConnextValidationService {
    constructor() {
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.http = inject(HttpClient);
      this.baseUrl = `${this.config.site === 'FGA' ? FlyGarminLegacyBaseUrl[this.config.environment] : '/flyadmin'}/api/validation`;
    }
    getAircraftSerialNumberRegex(payload) {
      return this.http.post(`${this.baseUrl}/aircraft/serialnumber/format`, payload);
    }
    validateAircraftSerialNumber(payload) {
      return this.http.post(`${this.baseUrl}/aircraft/serialnumber/validate`, payload);
    }
    static {
      this.ɵfac = function YarmouthConnextValidationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || YarmouthConnextValidationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: YarmouthConnextValidationService,
        factory: YarmouthConnextValidationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return YarmouthConnextValidationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let YarmouthSubscriptionsService = /*#__PURE__*/(() => {
  class YarmouthSubscriptionsService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.baseUrl = this.config.site === 'FGA' ? `${FlyGarminLegacyBaseUrl[this.config.environment]}/api/v2/subscriptions` : `${FlyAdminLegacyBaseUrl[this.config.environment]}/api/subscriptions`;
    }
    getSubscriptionByUuid(subscriptionUuid) {
      return this.http.get(`${this.baseUrl}/${subscriptionUuid}`);
    }
    static {
      this.ɵfac = function YarmouthSubscriptionsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || YarmouthSubscriptionsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: YarmouthSubscriptionsService,
        factory: YarmouthSubscriptionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return YarmouthSubscriptionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { YarmouthConnextService, YarmouthConnextValidationService, YarmouthSubscriptionsService, YarmouthSystemsService };
